import BaseApi from './BaseApi';

export type Token = {
  token: string;
};

/**
 * トークン発行API。
 */
class IssueTokenApi extends BaseApi {
  async get() {
    return await this.execute('athomeIssueTokenApi', {
      method: 'GET'
    }).then(({ result }) => result as Token);
  }
}

export default IssueTokenApi;
